import { useState, useEffect } from 'react';
import { SignupSuccessPage } from './auth/SignupSuccessPage';
import { DesktopSignupSuccessPage } from './desktop/DesktopSignupSuccessPage';

export function ResponsiveSignupSuccessPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SignupSuccessPage /> : <DesktopSignupSuccessPage />;
}